import React from 'react';
import { injectIntl } from 'react-intl';
import SingleButtonDropdown from '@rio-cloud/rio-uikit/lib/es/SingleButtonDropdown';
import PropTypes from 'prop-types';

import { appendActionsAsItems } from './common/FileUtils';
import VehicleConditionFilter from './VehicleConditionFilter';

const getActions = (formatMessage, { downloadTableAsCSV }) => {
    const items = appendActionsAsItems([], formatMessage({ id: 'intl-msg:csvExport' }), true, downloadTableAsCSV);
    return (
        <div className="ActionsDropdownButton margin-bottom-10">
            <SingleButtonDropdown title={formatMessage({ id: 'intl-msg:actions' })} items={items} />
        </div>
    );
};

const getAllActions = (formatMessage, props) => <div className="row no-gutter">{getActions(formatMessage, props)}</div>;

const getSelectedFilters = (formatMessage, { filters, onFilterRemove }) => (
    <ul className="list-inline margin-top-10">
        {filters.map((entry) => (
            <li key={entry.item} className="SelectedFilterTag">
                <div
                    className="tag tag-small deletable clickable rioglyph rioglyph-remove"
                    onClick={() => {
                        onFilterRemove(entry);
                    }}
                >
                    <span>{formatMessage({ id: `intl-msg:filter.vehicle_condition.severity.${entry.item}` })}</span>
                </div>
            </li>
        ))}
    </ul>
);

const getAllFilters = (formatMessage, props) => (
    <div className="panel panel-default panel-body">
        <VehicleConditionFilter filters={props.filters} />
        {getSelectedFilters(formatMessage, props)}
    </div>
);

const TableFilterBarWithoutInjection = (props) => {
    const {
        intl: { formatMessage },
    } = props;

    return (
        <div className="TableFilterBar">
            {getAllActions(formatMessage, props)}
            {getAllFilters(formatMessage, props)}
        </div>
    );
};

TableFilterBarWithoutInjection.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    downloadTableAsCSV: PropTypes.func.isRequired,
    filters: PropTypes.array.isRequired,
    onFilterRemove: PropTypes.func.isRequired,
};

export { TableFilterBarWithoutInjection };

export default injectIntl(TableFilterBarWithoutInjection);
